var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 919,
    viewBox: "0 0 1440 919",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_546)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_107_546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 919
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1440 0H0V919H1440V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_107_546)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M718.6 73.5681C371.385 54.5061 367.697 419.484 409.255 604.356C581.525 1078.79 882.715 794.902 868.475 486.322C854.234 177.741 1295.6 568.269 1462.83 221.795C1656.74 -179.956 1152.62 97.3951 718.6 73.5681Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95875,
    d: "M722.918 89.5029C376.58 58.3349 360.157 422.963 395.237 609.172C550.845 1089.33 861.759 816.13 858.296 507.236C854.834 198.347 1282.3 604.04 1461.52 263.613C1669.33 -131.126 1155.84 128.463 722.918 89.5029Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9175,
    d: "M726.674 105.579C381.634 62.3429 352.496 426.175 381.057 613.495C519.812 1098.79 840.071 836.6 847.391 527.782C854.71 218.96 1267.76 639.324 1458.75 305.359C1680.21 -81.8871 1157.97 159.624 726.674 105.579Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87625,
    d: "M729.867 121.775C386.547 66.5241 344.728 429.118 366.734 617.321C488.469 1107.16 817.683 856.31 835.776 547.935C853.869 239.556 1252 674.08 1454.53 346.984C1689.37 -32.2969 1159.02 190.84 729.867 121.775Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.835,
    d: "M732.497 138.074C391.314 70.8748 336.867 431.788 352.291 620.645C456.856 1114.43 794.625 875.23 823.469 567.67C852.313 260.111 1235.03 708.264 1448.85 388.435C1696.79 17.5807 1158.97 222.073 732.497 138.074Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.79375,
    d: "M734.551 154.454C395.921 75.3889 328.911 434.182 337.735 623.462C425.004 1120.6 770.914 893.33 810.474 586.963C850.035 280.598 1216.88 741.835 1441.74 429.664C1702.46 67.6879 1157.84 253.286 734.551 154.454Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7525,
    d: "M736.037 170.896C400.372 80.0609 320.882 436.297 323.095 625.77C392.96 1125.65 746.592 910.59 796.82 605.792C847.048 300.994 1197.57 774.752 1433.18 470.618C1706.39 117.963 1155.62 284.441 736.037 170.896Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71125,
    d: "M736.945 187.38C404.655 84.8865 312.78 438.131 308.379 627.565C360.757 1129.58 721.678 926.99 782.513 624.132C843.348 321.272 1177.12 806.975 1423.21 511.25C1708.55 168.344 1152.31 315.499 736.945 187.38Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.67,
    d: "M737.28 203.887C408.769 89.8575 304.623 439.681 293.613 628.847C328.439 1132.38 696.211 942.51 767.578 641.962C838.945 341.41 1155.57 838.471 1411.82 551.509C1708.96 218.77 1147.92 346.423 737.28 203.887Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.62875,
    d: "M737.036 220.393C412.705 94.9686 296.413 440.944 278.809 629.61C296.04 1134.05 670.214 957.14 752.027 659.259C833.84 361.381 1132.92 869.18 1399.03 591.345C1707.6 269.179 1142.45 377.174 737.036 220.393Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5875,
    d: "M736.215 236.882C416.459 100.215 288.164 441.921 263.985 629.858C263.601 1134.6 643.722 970.85 735.881 676.004C828.039 381.162 1109.22 899.09 1384.87 630.711C1704.49 319.51 1135.91 407.715 736.215 236.882Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54625,
    d: "M734.822 253.331C420.03 105.588 279.888 442.609 249.165 629.587C231.166 1134 616.77 983.62 719.163 692.174C821.555 400.729 1084.49 928.16 1369.33 669.558C1699.62 369.701 1128.31 438.01 734.822 253.331Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.505,
    d: "M732.853 269.722C423.409 111.083 271.59 443.008 234.361 628.8C198.769 1132.28 589.386 995.45 701.888 707.752C814.389 420.057 1058.75 956.34 1352.45 707.84C1693.01 419.693 1119.66 468.021 732.853 269.722Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.46375,
    d: "M730.318 286.036C426.599 116.694 263.288 443.118 219.598 627.497C166.456 1129.43 561.611 1006.31 684.085 722.717C806.558 439.124 1032.06 983.61 1334.25 745.51C1684.65 469.423 1109.97 497.713 730.318 286.036Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4225,
    d: "M727.211 302.249C429.587 122.411 254.984 442.937 204.885 625.679C134.259 1125.45 533.47 1016.2 665.766 737.051C798.062 457.905 1004.42 1009.93 1314.74 782.52C1674.56 518.831 1099.24 527.047 727.211 302.249Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38125,
    d: "M723.543 318.346C432.377 128.23 246.694 442.467 190.248 623.35C102.223 1120.35 505.004 1025.1 646.961 750.738C788.919 476.38 975.887 1035.27 1293.95 818.83C1662.76 567.857 1087.5 555.99 723.543 318.346Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M719.313 334.303C434.959 134.142 238.423 441.707 175.698 620.51C70.382 1114.14 476.241 1033 627.687 763.76C779.133 494.523 946.483 1059.6 1271.91 854.39C1649.25 616.441 1074.75 584.505 719.313 334.303Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29875,
    d: "M714.529 350.104C437.334 140.141 230.184 440.659 161.258 617.164C38.7772 1106.82 447.222 1039.89 607.972 776.101C768.722 512.313 916.248 1082.88 1248.63 889.16C1634.05 664.524 1061.02 612.558 714.529 350.104Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2575,
    d: "M709.196 365.728C439.498 146.219 221.985 439.325 146.941 613.317C7.4469 1098.4 417.978 1045.76 587.836 787.747C757.695 529.73 885.219 1105.1 1224.16 923.09C1617.19 712.048 1046.32 640.115 709.196 365.728Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21625,
    d: "M703.324 381.157C441.45 152.369 213.841 437.706 132.771 608.972C-23.5673 1088.89 388.551 1050.62 567.31 798.684C746.069 546.752 853.436 1126.22 1198.53 956.15C1598.67 758.954 1030.66 667.142 703.324 381.157Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.175,
    d: "M696.913 396.371C443.184 158.583 205.755 435.802 118.757 604.135C-54.2348 1078.3 358.968 1054.44 546.41 808.896C733.853 563.356 820.931 1146.22 1171.75 988.3C1578.53 805.185 1014.07 693.605 696.913 396.371Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.13375,
    d: "M689.976 411.352C444.7 164.854 197.741 433.618 104.921 598.813C-84.5131 1066.65 329.27 1057.22 525.168 818.37C721.066 579.525 787.749 1165.07 1143.86 1019.49C1556.79 850.68 996.571 719.474 689.976 411.352Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.0925,
    d: "M682.523 426.082C445.999 171.174 189.811 431.156 91.2824 593.01C-114.364 1053.96 299.497 1058.97 503.611 827.1C707.725 595.237 753.932 1182.76 1114.91 1049.69C1533.48 895.4 978.178 744.717 682.523 426.082Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05125,
    d: "M674.557 440.543C447.073 177.535 181.968 428.418 77.851 586.735C-143.757 1040.22 269.676 1059.68 481.758 835.08C693.84 610.475 719.516 1199.25 1084.92 1078.86C1508.61 939.27 958.912 769.302 674.557 440.543Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.01,
    d: "M666.094 454.717C447.926 183.931 174.227 425.408 64.6484 579.996C-172.651 1025.47 239.851 1059.34 459.643 842.28C679.434 625.218 684.546 1214.53 1053.93 1106.97C1482.24 982.25 938.802 793.199 666.094 454.717Z",
    stroke: "#E2E8F0",
    strokeWidth: 3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_546"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 919,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgAsset);
export default __webpack_public_path__ + "static/media/bg-asset.f3ba993075f0469c781f95eb41b3c8a6.svg";
export { ForwardRef as ReactComponent };